

$(function () {
    $(".progress .progress-bar").each(function (idx, element) {
        setTimeout(function () {
            var value = $(element).attr("aria-valuenow");
            $(element).css("width", value + "%");
        }, 500);
    });
})